import styled from "@emotion/styled";

export const Container = styled.div`
    flex:1 0 auto; 
    display:flex;
    flex-flow:column nowrap;
    justify-content:center;
    align-items:center;   
`